import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AllAppsRaw = React.lazy(() => import(/* webpackChunkName: "AdminAllApps" */ './AllApps'));
export const AllAppearances = () => (React.createElement(Page, { title: "All Appearances", description: "All Appearances" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AllAppsRaw, null)))));
